import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconAvatar from 'Views/Onboarding/Components/IconAvatar';

const styles = theme => ({
  root: {},
  img: {
    filter: theme.filters.primaryBlue,
  },
});

const MonotoneIconAvatar = ({
  className,
  classes,
  ...rest
}) => {
  return (
    <IconAvatar
      classes={{
        root: classNames(classes.root, className),
        img: classes.img,
      }}
      {...rest}
    />
  );
};

MonotoneIconAvatar.defaultProps = {
  className: '',
};

MonotoneIconAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MonotoneIconAvatar);
